// 页面样式
import css from 'css/page/article.scss'

// 常量
import * as constants from 'js/constants/index'
// 公共方法
import {
  comment,
  dataBus,
  domObserver,
  memberShip,
  message,
  qrcode,
} from 'js/common/index'
// 工具方法
import * as utils from 'js/utils/index'

/**
 * 绑定 DOM 事件
 */
function bindEvts() {
  memberFormInit()
  commentEvtsInit()
}

/**
 * 评论事件初始化
 */
function commentEvtsInit() {
  let maskObj = document.querySelector('.mask-cmmt')

  if (!maskObj) {
    utils.log.e('comment mask not found.')
    return
  }

  comment.publishInit({
    badBtn: maskObj.querySelector('.yui-icon-cry0-yellow').parentNode,
    cancelBtn: '.yui-ccmmt-publish0 .btn-op.cancel',
    cancelSuccess: hideMask,
    data: {
      gameId: document.querySelector('.sec-cmmt').getAttribute(constants.api.gameIdPropertyName),
    },
    goodBtn: maskObj.querySelector('.yui-icon-smile0-yellow').parentNode,
    ipt: '.yui-ccmmt-publish0 textarea',
    submitBtn: '.yui-ccmmt-publish0 .btn-op.push',
    submitSuccessBefore: () => window.location.href = window.location.href,
    submitFinally: hideMask,
  })

  comment.thumbInit({
    list: '.cmmt-blk',
    btnSelector: '.btn-thumb',
  })

  for (let o of document.querySelectorAll('.sec-cmmt .yui-thumbbtn0')) {
    o.addEventListener('click', showMask, false)
  }

  function showMask() {
    if (!maskObj) {
      utils.log.e('comment mask not found.')
      return
    }

    let user = dataBus.get('user')
    if (!user) {
      return message.common.pleaseLogin({
        callback: () => {
          let obj = document.querySelector('header a.login')
          if (obj) {
            obj.click()
          }
        },
        mode: 1,
      })
    }

    let obj = $(this).find('.yui-icon-smile0-yellow')
    if (obj.length > 0) {
      $('.mask-cmmt .yui-icon-cry0-yellow').toggleClass('yui-icon-cry0-yellow yui-icon-cry0-gray')
    }

    obj = $(this).find('.yui-icon-cry0-yellow')
    if (obj.length > 0) {
      $('.mask-cmmt .yui-icon-smile0-yellow').toggleClass('yui-icon-smile0-yellow yui-icon-smile0-gray')
    }

    maskObj.style.display = 'block'
  }

  function hideMask() {
    if (!maskObj) {
      utils.log.e('comment mask not found.')
      return
    }

    let obj = document.querySelector('.mask-cmmt .yui-icon-smile0-yellow, .mask-cmmt .yui-icon-smile0-gray')
    if (obj) {
      $(obj).addClass('yui-icon-smile0-yellow').removeClass('yui-icon-smile0-gray')
    }

    obj = document.querySelector('.mask-cmmt .yui-icon-cry0-yellow, .mask-cmmt .yui-icon-cry0-gray')
    if (obj) {
      $(obj).addClass('yui-icon-cry0-yellow').removeClass('yui-icon-cry0-gray')
    }

    document.querySelector('.mask-cmmt textarea').value = ''
    maskObj.style.display = 'none'
  }
}

/**
 * 评论 UI 初始化
 */
function cmmtUIInit() {
  comment.loadCmmtList({
    mode: 0,
    params: {
      desc: '.desc-load',
      id: '.sec-cmmt',
      pageList: '.yui-pagination0 .pagelist',
      target: '.sec-cmmt .cmmt-blk',
    },
  })
  comment.loadGood({
    bad: '.txt-add.bad',
    data: {
      gameId: document.querySelector('.sec-cmmt').getAttribute(constants.api.gameIdPropertyName)
    },
    good: '.txt-add.good',
  })
  comment.loadUserData({
    avatar: '.yui-ccmmt-top0 .avatar img',
    mode: 1,
    mode1Callback: () => {
      let obj = document.querySelector('header a.login')
      if (obj) {
        obj.click()
      }
    },
    userName: '.yui-ccmmt-top0 .avatar .username',
  })
}

/**
 * 登录相关表单初始化
 */
function memberFormInit() {
  memberShip.closeForm.init()
  memberShip.forgetPwdFormInit({
    form: '.yui-memberform0-forgetpwd',
    mask: '.mask-member',
  })
  memberShip.loginFormInit({
    success: () => {
      // 登陆完毕刷新页面，初始化头部和评论点赞状态
      window.location.href = window.location.href
    },
    form: '.yui-memberform0-login',
    mask: '.mask-member',
  })
  memberShip.registerFormInit({
    form: '.yui-memberform0-register',
    mask: '.mask-member',
  })
}

/**
 * 二维码初始化
 */
function QRCodeInit() {
  let parser = new utils.UrlParser()

  qrcode.init({
    ht: 140,
    prefix: parser.domainName,
    target: '.yui-qrbtn0 .qrcode',
    wt: 140,
  })
}

/**
 * UI 初始化
 */
function uiInit() {
  QRCodeInit()
  cmmtUIInit()
}

window._dataBus.get('domReadyObserver').subscribe(() => {
  uiInit()
  bindEvts()
})


// WEBPACK FOOTER //
// ./js/page/article.js